<template>
  <div class="animated fadeIn overflow-auto">
    <div class="pre-scrollable  " style="max-height: 85vh; overflow-x: hidden;">
      <b-navbar :no-body="true" class="p-0 " fixed :sticky="true" toggleable="lg" type="light" variant="light">
        <b-navbar-brand>
            <i class="fa fa-address-book-o bg-info p-3 font-2xl mr-3 float-left "></i>
            <div class="h5 text-muted mb-0 mt-2" style="padding-right: 150px !important;">
              Cadastro de Produto
            </div>
            <div class="text-muted text-uppercase font-weight-bold font-xs" >
              PRODUTO: {{registro.CODIGO}} <span v-if="registro.CODIGO > 0 ">-</span> {{registro.DESCRICAO ? registro.DESCRICAO.substring(0,22) : ""}}
            </div>
        </b-navbar-brand>
        
         
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <b-button size="lg" variant="outline-info" class="px-3 font-weight-bold" type="button" @click.stop.prevent="voltar()" > 
                   <i class="fa fa-arrow-left"></i>  Voltar
              </b-button>
              <b-button size="lg" class="px-4 font-weight-bold" variant="success" type="button" @click.stop.prevent="postOrEdit()" > 
                  <i class="fa fa-save"></i>  Gravar
              </b-button> 
            </b-nav-form>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>

      <b-row class="align-stretch">
        <b-col sm="9" class="d-flex pr-0">

          <b-card body-class="bg-gray-100" class="w-100 h-100">
            <div slot="header">
              <strong>  Identificação</strong>
            </div>
            
            <b-row>
              <!--/.col-->
              <b-col sm="2">
                <b-form-fieldset label="Código">
                  <b-form-input type="text" id="ID" :disabled="true" placeholder="Código Automático" v-model="registro.CODIGO"></b-form-input>
                </b-form-fieldset>
              </b-col>
              <!--/.col-->
              <b-col sm="3">
                <b-form-fieldset label="EAN 13">
                  <b-form-input type="text" id="edEAN"  placeholder="" v-model="registro.EAN"></b-form-input>
                </b-form-fieldset>
              </b-col>
              <!--/.col-->
              <b-col sm="3">
                <b-form-fieldset label="NCM">
                  <b-form-input type="text" id="edTX_NCM" ref="edTX_NCM" placeholder="" v-model="registro.TX_NCM" :state="!!registro.TX_NCM"></b-form-input>
                </b-form-fieldset>
              </b-col>
              <!--/.col-->
              <b-col sm="2">
                <b-form-fieldset label="CEST">
                  <b-form-input type="text" id="edCES"  placeholder="" v-model="registro.CEST"></b-form-input>
                </b-form-fieldset>
              </b-col>
              <!--/.col-->
              <b-col sm="2">
                <b-form-fieldset label="SIE">
                  <b-form-input type="text" id="edSIE"  placeholder="" v-model="registro.SIE"></b-form-input>
                </b-form-fieldset>
              </b-col>
            </b-row> 
            <b-row >
              <!--/.col-->
              <b-col sm="8">
                <b-form-fieldset label="Descrição">
                  <b-form-input type="text" id="edDESCRICAO" ref="edDESCRICAO" :disabled="false" 
                  placeholder="Informe a descrição min(3 letras)"
                  v-model="registro.DESCRICAO"
                  :state="!!registro.DESCRICAO"> </b-form-input>
                </b-form-fieldset>
              </b-col>  
              <!--/.col-->
              <b-col sm="4">
                <b-form-fieldset label="Resumido">
                  <b-form-input type="text" id="edREZUMIDO" ref="edREZUMIDO" :disabled="false" 
                  placeholder="Informe o Resumido min(3 letras)" 
                  v-model="registro.REZUMIDO"
                  :state="!!registro.REZUMIDO"> </b-form-input>
                </b-form-fieldset>
              </b-col>  
            </b-row>  
            <b-row>
              <b-col sm="6">
                <cliente-pesquisa 
                  @retornaId="registro.COD_FOR = $event"
                  :idInicial="registro.COD_FOR"
                  :classeRequired="true"
                  :desabilitarInput="false"
                  label="Fornecedor Preferencial"
                  id-modal="modalCliente"
                  id="edCOD_FOR"
                  ref="edCOD_FOR"
                  place=""
                  labelBotao="">
                </cliente-pesquisa>
              </b-col>
              <b-col sm="6">
                <grupo-produto-pesquisa
                  @retornaId="registro.COD_GRUP = $event"
                  :idInicial="registro.COD_GRUP"
                  :classeRequired="true"
                  :desabilitarInput="false"
                  label="Grupo"
                  id-modal="modalGrupoProduto"
                  id="edCOD_GRUP"
                  ref="edCOD_GRUP"
                  place=""
                  labelBotao="">
                </grupo-produto-pesquisa>
              </b-col>
            </b-row>
              
          </b-card>
        </b-col>
        
        <b-col sm="3" class="d-flex pl-0">
          <b-card body-class="bg-gray-100" class="w-100 h-100">
            <div slot="header">
              <strong>Marcadores</strong>
            </div>
            <b-row>
              <b-col sm="6">
                <b-form-checkbox
                    id="checkbox-1"
                    v-model="registro.OP_SITUACAO"
                    name="checkbox-1"
                    value="1"
                    unchecked-value="0">
                    Ativo
                </b-form-checkbox>
              </b-col>
              <b-col sm="6">
                <b-form-checkbox id="checkbox1"
                    v-model="registro.OP_PERMITE_VENDA"
                    value="1"
                    unchecked-value="0">
                  Permite Venda
                </b-form-checkbox>
              </b-col>
            </b-row>   
            <b-row>
              <b-col sm="6">
                <b-form-checkbox id="checkbox2"
                    v-model="registro.OP_BENEFICIA"
                    value="1"
                    unchecked-value="0">
                  Beneficia
                </b-form-checkbox>
              </b-col>
              <b-col sm="6">
                <b-form-checkbox
                    id="checkbox-1"
                    v-model="registro.OP_BENEFICIADO"
                    name="checkbox-1"
                    value="1"
                    unchecked-value="0">
                    Beneficiado
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6">
                <b-form-checkbox id="checkbox1"
                    v-model="registro.OP_GRADE"
                    value="1"
                    unchecked-value="0">
                  Grade
                </b-form-checkbox>
              </b-col>
              <b-col sm="6">
                <b-form-checkbox id="checkbox2"
                    v-model="registro.OP_ANIMAL"
                    value="1"
                    unchecked-value="0">
                  Animal
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row>  
              <b-col sm="6">
                <b-form-checkbox
                    id="checkbox-1"
                    v-model="registro.OP_MOSTRAR_APP"
                    name="checkbox-1"
                    value="1"
                    unchecked-value="0">
                    Mostrar APP
                </b-form-checkbox>
              </b-col>
              <b-col sm="6">
                <b-form-checkbox id="checkbox1"
                    v-model="registro.OP_MATERIA_PRIMA"
                    value="1"
                    unchecked-value="0">
                  Materia Prima
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row>  
              <b-col sm="6">
                <b-form-checkbox id="checkbox2"
                    v-model="registro.OP_QUARTO"
                    value="1"
                    unchecked-value="0">
                  Quarto
                </b-form-checkbox>
              </b-col>
              <b-col sm="6">
                <b-form-checkbox
                    id="checkbox-1"
                    v-model="registro.OP_BANDA"
                    name="checkbox-1"
                    value="1"
                    unchecked-value="0">
                    Banda
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row>  
              <b-col sm="6">
                <b-form-checkbox id="checkbox1"
                    v-model="registro.OP_PESADO"
                    value="1"
                    unchecked-value="0">
                  Pesado
                </b-form-checkbox>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col sm="12">
                <b-form-checkbox id="cbOP_PRODUTO_PRODUCAO" ref="cbOP_PRODUTO_PRODUCAO"
                    v-model="registro.OP_PRODUTO_PRODUCAO"
                    value="1"
                    unchecked-value="0">
                  Produto do Estoque da Produção
                </b-form-checkbox>
              </b-col>
            </b-row>  
            <b-row>
              <b-col sm="12">
                <b-form-checkbox id="cbOP_CONFIRMAR_PECAS_EXPEDICAO" ref="cbOP_CONFIRMAR_PECAS_EXPEDICAO"
                    v-model="registro.OP_CONFIRMAR_PECAS_EXPEDICAO"
                    value="1"
                    unchecked-value="0">
                  Confirmar Peças na Expedição
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <b-form-checkbox id="cb" ref="cbOP_PESO_FIXO"
                    v-model="registro.OP_PESO_FIXO"
                    value="1"
                    unchecked-value="0">
                  Peso Fixo = Peso Bruto
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12">
                <b-form-checkbox id="cbOP_ESTOQUE" ref="cbOP_ESTOQUE"
                    v-model="registro.OP_ESTOQUE"
                    value="1"
                    unchecked-value="0">
                  Controla Estoque
                </b-form-checkbox>
              </b-col>
            </b-row>


            
              
          </b-card>
        </b-col>
      </b-row>
      <div>
        <b-card no-body>
          <b-tabs card class="bg-gray-100"  content-class="bg-gray-100">
            <b-tab  active>
              <template #title>
                <i class='fa fa-list-alt'></i><strong> Estocagem</strong>
              </template>
              <b-row>
                <b-col sm="2">
                  <b-form-fieldset label="UND Comercializada">
                    <b-form-select 
                        v-model="registro.ID_UNIDADE_COMERCIAL" 
                        ref="comboID_UNIDADE_COMERCIAL"
                        :options="optionsID_UNIDADE_COMERCIAL"  
                        :state="!!registro.ID_UNIDADE_COMERCIAL"
                        >
                    </b-form-select>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="Quant. Embalagem">
                    <vue-autonumeric  v-model="registro.QT_EMBALAGEM" 
                                      ref="edQT_EMBALAGEM"
                                        :disabled="false"
                                        :options="{
                                              digitGroupSeparator: '.',
                                              decimalCharacter: ',',
                                              decimalCharacterAlternative: '.',
                                              decimalPlaces: '0',
                                              roundingMethod: 'U',
                                              minimumValue: '0',
                                              maxValue: 10000
                                        }"
                                        :class="['form-control', {
                                          'is-valid' : registro.QT_EMBALAGEM,
                                          'is-invalid' : !registro.QT_EMBALAGEM
                                        }]">
                    </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="Estq. Min">
                    <vue-autonumeric  v-model="registro.EST_MIN" 
                                      ref="edEST_MIN"
                                        :disabled="false"
                                        :options="{
                                              digitGroupSeparator: '.',
                                              decimalCharacter: ',',
                                              decimalCharacterAlternative: '.',
                                              decimalPlaces: '3',
                                              roundingMethod: 'U',
                                              minimumValue: '0',
                                              maxValue: 10000
                                        }"
                                        :class="['form-control', {
                                          'is-valid' : registro.EST_MIN,
                                          'is-invalid' : !registro.EST_MIN
                                        }]">
                    </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="Estq. Máx">
                    <vue-autonumeric  v-model="registro.EST_MAX" 
                                      ref="edEST_MAX"
                                        :disabled="false"
                                        :options="{
                                              digitGroupSeparator: '.',
                                              decimalCharacter: ',',
                                              decimalCharacterAlternative: '.',
                                              decimalPlaces: '3',
                                              roundingMethod: 'U',
                                              minimumValue: '0',
                                              maxValue: 10000
                                        }"
                                        :class="['form-control', {
                                          'is-valid' : registro.EST_MAX,
                                          'is-invalid' : !registro.EST_MAX
                                        }]">
                    </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="Peso Bruto">
                    <vue-autonumeric  v-model="registro.PESO" 
                                      ref="edPESO"
                                        :disabled="false"
                                        :options="{
                                              digitGroupSeparator: '.',
                                              decimalCharacter: ',',
                                              decimalCharacterAlternative: '.',
                                              decimalPlaces: '3',
                                              roundingMethod: 'U',
                                              minimumValue: '0',
                                              maxValue: 10000
                                        }"
                                        :class="['form-control', {
                                          'is-valid' : registro.PESO,
                                          'is-invalid' : !registro.PESO
                                        }]">
                    </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="Peso Líquido">
                    <vue-autonumeric  v-model="registro.PESO_LIQUIDO" 
                                      ref="edPESO_LIQUIDO"
                                        :disabled="false"
                                        :options="{
                                              digitGroupSeparator: '.',
                                              decimalCharacter: ',',
                                              decimalCharacterAlternative: '.',
                                              decimalPlaces: '3',
                                              roundingMethod: 'U',
                                              minimumValue: '0',
                                              maxValue: 10000
                                        }"
                                        :class="['form-control', {
                                          'is-valid' : registro.PESO_LIQUIDO,
                                          'is-invalid' : !registro.PESO_LIQUIDO
                                        }]">
                    </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
              </b-row> 
              <b-row>
                <b-col sm="2">
                  <b-form-fieldset label="Tara Embalagem">
                    <vue-autonumeric  v-model="registro.TARA_EMBALAGEM" 
                                      ref="edTARA_EMBALAGEM"
                                        :disabled="false"
                                        :options="{
                                              digitGroupSeparator: '.',
                                              decimalCharacter: ',',
                                              decimalCharacterAlternative: '.',
                                              decimalPlaces: '3',
                                              roundingMethod: 'U',
                                              minimumValue: '0',
                                              maxValue: 10000
                                        }"
                                        :class="['form-control', {
                                          'is-valid' : registro.TARA_EMBALAGEM,
                                          'is-invalid' : !registro.TARA_EMBALAGEM
                                        }]">
                    </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="Dias validade">
                    <vue-autonumeric  v-model="registro.VALIDADE" 
                                      ref="edVALIDADE"
                                        :disabled="false"
                                        :options="{
                                              digitGroupSeparator: '.',
                                              decimalCharacter: ',',
                                              decimalCharacterAlternative: '.',
                                              decimalPlaces: '0',
                                              roundingMethod: 'U',
                                              minimumValue: '0',
                                              maxValue: 10000
                                        }"
                                        :class="['form-control', {
                                          'is-valid' : registro.VALIDADE,
                                          'is-invalid' : !registro.VALIDADE
                                        }]">
                    </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="Armazenamento">
                    <b-form-select 
                          :plain="true" 
                          v-model="registro.OP_TIPO_ESTOCAGEM" 
                          :state="!!registro.OP_TIPO_ESTOCAGEM"
                          :options="optionsOP_TIPO_ESTOCAGEM">
                    </b-form-select>
                  </b-form-fieldset>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <b-form-fieldset label="Mensagem Armazenamento">
                    <b-form-input type="text" id="edMENSAGEM_ARMAZENAMENTO"  placeholder="" v-model="registro.MENSAGEM_ARMAZENAMENTO"></b-form-input>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="4">
                  <b-form-fieldset label="Mensagem Conservação">
                    <b-form-input type="text" id="edMENSAGEM_CONSERVACAO"  placeholder="" v-model="registro.MENSAGEM_CONSERVACAO"></b-form-input>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="Temp. Mínima">
                    <vue-autonumeric  v-model="registro.TEMPERATURA_MINIMA" 
                                      ref="edTEMPERATURA_MINIMA"
                                        :disabled="false"
                                        :options="{
                                              digitGroupSeparator: '.',
                                              decimalCharacter: ',',
                                              decimalCharacterAlternative: '.',
                                              decimalPlaces: '0',
                                              roundingMethod: 'U',
                                              minimumValue: '0',
                                              maxValue: 10000
                                        }"
                                        :class="['form-control', {
                                          'is-valid' : registro.TEMPERATURA_MINIMA,
                                          'is-invalid' : !registro.TEMPERATURA_MINIMA
                                        }]">
                    </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="Temp. Máxima">
                    <vue-autonumeric  v-model="registro.TEMPERATURA_MAXIMA" 
                                      ref="edTEMPERATURA_MAXIMA"
                                        :disabled="false"
                                        :options="{
                                              digitGroupSeparator: '.',
                                              decimalCharacter: ',',
                                              decimalCharacterAlternative: '.',
                                              decimalPlaces: '0',
                                              roundingMethod: 'U',
                                              minimumValue: '0',
                                              maxValue: 10000
                                        }"
                                        :class="['form-control', {
                                          'is-valid' : registro.TEMPERATURA_MAXIMA,
                                          'is-invalid' : !registro.TEMPERATURA_MAXIMA
                                        }]">
                    </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
              </b-row>
            </b-tab>
            
            <b-tab >
              <template #title>
                <i class='fa fa-inbox'></i><strong> Embalagem</strong>
              </template>
              <b-row>
                <b-col sm="2">
                  <b-form-fieldset label="Formato">
                    <b-form-select 
                          :plain="true" 
                          v-model="registro.FORMATO_EMBALAGEM_ID" 
                          :options="optionsFORMATO_EMBALAGEM_ID">
                    </b-form-select>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="Capacidade">
                    <vue-autonumeric  v-model="registro.CAPACIDADE" 
                                      ref="edCAPACIDADE"
                                        :disabled="false"
                                        :options="{
                                              digitGroupSeparator: '.',
                                              decimalCharacter: ',',
                                              decimalCharacterAlternative: '.',
                                              decimalPlaces: '3',
                                              roundingMethod: 'U',
                                              minimumValue: '0',
                                              maximumValue: 1000
                                        }"
                                        class="form-control">
                    </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="1">
                  <b-form-fieldset label="Unds">
                    <b-form-select 
                        v-model="registro.UNIDADE_COMERCIAL_CAPACIDADE_ID" 
                        :options="optionsID_UNIDADE_COMERCIAL"  
                        >
                    </b-form-select>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="Cor">
                    <b-form-select 
                          :plain="true" 
                          v-model="registro.COR_ID" 
                          :options="optionsCOR_ID">
                    </b-form-select>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="Material">
                    <b-form-select 
                          :plain="true" 
                          v-model="registro.MATERIAL_ID" 
                          :options="optionsMATERIAL_ID">
                    </b-form-select>
                  </b-form-fieldset>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab >
              <template #title>
                <i class='fa fa-barcode'></i><strong> Terminais de Etiquetas</strong>
              </template>
              <b-row>
                <b-col sm="4">
                  <b-form-fieldset label="Expedição">
                    <b-form-select 
                          :plain="true" 
                          v-model="registro.ETIQUETA_EXPEDICAO_ID" 
                          :options="optionsETIQUETAS">
                    </b-form-select>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="4">
                  <b-form-fieldset label="Saída Desossa Encaixot">
                    <b-form-select 
                          :plain="true" 
                          v-model="registro.ETIQUETA_DESOSSA_ID" 
                          :options="optionsETIQUETAS">
                    </b-form-select>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="4">
                  <b-form-fieldset label="Interna">
                    <b-form-select 
                          :plain="true" 
                          v-model="registro.ETIQUETA_INTERNA_ID" 
                          :options="optionsETIQUETAS">
                    </b-form-select>
                  </b-form-fieldset>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="4">
                  <b-form-fieldset label="Resumo Miúdo">
                    <b-form-select 
                          :plain="true" 
                          v-model="registro.ETIQUETA_RESUMO_ABATE_ID" 
                          :options="optionsETIQUETAS">
                    </b-form-select>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="4">
                  <b-form-fieldset label="Beneficiamento">
                    <b-form-select 
                          :plain="true" 
                          v-model="registro.ETIQUETA_BENEFICIAMENTO_ID" 
                          :options="optionsETIQUETAS">
                    </b-form-select>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="4">
                  <b-form-fieldset label="Recepçao de Mercadoria">
                    <b-form-select 
                          :plain="true" 
                          v-model="registro.ETIQUETA_RECEPCAO_ID" 
                          :options="optionsETIQUETAS">
                    </b-form-select>
                  </b-form-fieldset>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab>
              <template #title>
                <i class='fa fa-coffee'></i><strong> Dados Nutricionais</strong>
              </template>
              <!-- Quantidade -->
              <b-row>
                <b-col sm="6">
                  <b-input-group  >
                    <template #prepend>
                      <span class="input-group-text bg-gray-100 prepend-160"></span>
                    </template>
                    <b-form-input :disabled="true" placeholder="Porção 1" class="text-center"> </b-form-input>
                    <b-form-input :disabled="true" placeholder="%" class="text-center" ></b-form-input>
                    <b-form-input :disabled="true" placeholder="Porção 2" class="text-center"></b-form-input>
                    <b-form-input :disabled="true" placeholder="%" class="text-center" ></b-form-input>
                  </b-input-group>
                  <b-input-group>
                     <template #prepend>
                      <span class="input-group-text prepend-160">Quantidade</span>
                    </template>
                    <b-form-input type="text"  v-model="registro.QUANTIDADE_PORCAO" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.QUANTIDADE_PORCAO_PORCENTO" :options="formatoPercentual"  class="form-control text-right"> </vue-autonumeric>
                    <b-form-input type="text"  v-model="registro.QUANTIDADE_PORCAO2" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.QUANTIDADE_PORCAO_PORCENTO2" :options="formatoPercentual" class="form-control text-right"> </vue-autonumeric>
                  </b-input-group>
                   <b-input-group >
                    <template #prepend>
                      <span class="input-group-text prepend-160">Valor Energetico</span>
                    </template>
                    <b-form-input type="text"  v-model="registro.VALOR_ENERGETICO" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.VALOR_ENERGETICO_PORCENTO" :options="formatoPercentual"  class="form-control text-right"> </vue-autonumeric>
                    <b-form-input type="text"  v-model="registro.VALOR_ENERGETICO2" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.VALOR_ENERGETICO2" :options="formatoPercentual" class="form-control text-right"> </vue-autonumeric>
                  </b-input-group>
                   <b-input-group>
                    <template #prepend>
                      <span class="input-group-text prepend-160">Carboidratos</span>
                    </template>
                    <b-form-input type="text"  v-model="registro.CARBOIDRATOS" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.CARBOIDRATOS_PORCENTO" :options="formatoPercentual"  class="form-control text-right"> </vue-autonumeric>
                    <b-form-input type="text"  v-model="registro.CARBOIDRATOS2" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.CARBOIDRATOS_PORCENTO2" :options="formatoPercentual" class="form-control text-right"> </vue-autonumeric>
                  </b-input-group>
                  <b-input-group >
                    <template #prepend>
                      <span class="input-group-text prepend-160">Gorduras Trans</span>
                    </template>
                    <b-form-input type="text"  v-model="registro.GORDURAS_TRANS" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.GORDURAS_TRANS_PORCENTO" :options="formatoPercentual"  class="form-control text-right"> </vue-autonumeric>
                    <b-form-input type="text"  v-model="registro.GORDURAS_TRANS2" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.GORDURAS_TRANS_PORCENTO2" :options="formatoPercentual" class="form-control text-right"> </vue-autonumeric>
                  </b-input-group>
                  <b-input-group>
                    <template #prepend>
                      <span class="input-group-text prepend-160">Gorduras Totais</span>
                    </template>
                    <b-form-input type="text"  v-model="registro.ACUCARES_TOTAIS" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.ACUCARES_TOTAIS_PORCENTO" :options="formatoPercentual"  class="form-control text-right"> </vue-autonumeric>
                    <b-form-input type="text"  v-model="registro.ACUCARES_TOTAIS2" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.ACUCARES_TOTAIS_PORCENTO2" :options="formatoPercentual" class="form-control text-right"> </vue-autonumeric>
                  </b-input-group>
                   <b-input-group>
                    <template #prepend>
                      <span class="input-group-text prepend-160">Cálcio</span>
                    </template>
                    <b-form-input type="text"  v-model="registro.CALCIO" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.CALCIO_PORCENTO" :options="formatoPercentual"  class="form-control text-right"> </vue-autonumeric>
                    <b-form-input type="text"  v-model="registro.CALCIO2" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.CALCIO_PORCENTO2" :options="formatoPercentual" class="form-control text-right"> </vue-autonumeric>
                  </b-input-group>
                   <b-input-group>
                    <template #prepend>
                      <span class="input-group-text prepend-160">Proteína</span>
                    </template>
                    <b-form-input type="text"  v-model="registro.PROTEINAS" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.PROTEINAS_PORCENTO" :options="formatoPercentual"  class="form-control text-right"> </vue-autonumeric>
                    <b-form-input type="text"  v-model="registro.PROTEINAS2" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.PROTEINAS_PORCENTO2" :options="formatoPercentual" class="form-control text-right"> </vue-autonumeric>
                  </b-input-group>

                </b-col>

                <b-col sm="6">
                  <b-input-group  >
                    <template #prepend>
                      <span class="input-group-text bg-gray-100 prepend-160"></span>
                    </template>
                    <b-form-input :disabled="true" placeholder="Porção 1" class="text-center"> </b-form-input>
                    <b-form-input :disabled="true" placeholder="%" class="text-center" ></b-form-input>
                    <b-form-input :disabled="true" placeholder="Porção 2" class="text-center"></b-form-input>
                    <b-form-input :disabled="true" placeholder="%" class="text-center" ></b-form-input>
                  </b-input-group>
                  <b-input-group>
                     <template #prepend>
                      <span class="input-group-text prepend-160">Gorduras Saturadas</span>
                    </template>
                    <b-form-input type="text"  v-model="registro.GORDURAS_SATURADAS" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.GORDURAS_SATURADAS_PORCENTO" :options="formatoPercentual"  class="form-control text-right"> </vue-autonumeric>
                    <b-form-input type="text"  v-model="registro.GORDURAS_SATURADAS2" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.GORDURAS_SATURADAS_PORCENTO2" :options="formatoPercentual" class="form-control text-right"> </vue-autonumeric>
                  </b-input-group>
                   <b-input-group >
                    <template #prepend>
                      <span class="input-group-text prepend-160">Gorduras Totais</span>
                    </template>
                    <b-form-input type="text"  v-model="registro.GORDURAS_TOTAIS" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.GORDURAS_TOTAIS_PORCENTO" :options="formatoPercentual"  class="form-control text-right"> </vue-autonumeric>
                    <b-form-input type="text"  v-model="registro.GORDURAS_TOTAIS2" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.GORDURAS_TOTAIS_PORCENTO2" :options="formatoPercentual" class="form-control text-right"> </vue-autonumeric>
                  </b-input-group>
                   <b-input-group>
                    <template #prepend>
                      <span class="input-group-text prepend-160">Fibra Alimentar</span>
                    </template>
                    <b-form-input type="text"  v-model="registro.FIBRA_ALIMENTAR" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.FIBRA_ALIMENTAR_PORCENTO" :options="formatoPercentual"  class="form-control text-right"> </vue-autonumeric>
                    <b-form-input type="text"  v-model="registro.FIBRA_ALIMENTAR2" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.FIBRA_ALIMENTAR_PORCENTO2" :options="formatoPercentual" class="form-control text-right"> </vue-autonumeric>
                  </b-input-group>
                  <b-input-group >
                    <template #prepend>
                      <span class="input-group-text prepend-160">Colesterol</span>
                    </template>
                    <b-form-input type="text"  v-model="registro.COLESTEROL" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.COLESTEROL_PORCENTO" :options="formatoPercentual"  class="form-control text-right"> </vue-autonumeric>
                    <b-form-input type="text"  v-model="registro.COLESTEROL2" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.COLESTEROL_PORCENTO2" :options="formatoPercentual" class="form-control text-right"> </vue-autonumeric>
                  </b-input-group>
                  <b-input-group>
                    <template #prepend>
                      <span class="input-group-text prepend-160">Açucares Adicionados</span>
                    </template>
                    <b-form-input type="text"  v-model="registro.ACUCARES_ADICIONADOS" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.ACUCARES_ADICIONADOS_PORCENTO" :options="formatoPercentual"  class="form-control text-right"> </vue-autonumeric>
                    <b-form-input type="text"  v-model="registro.ACUCARES_ADICIONADOS2" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.ACUCARES_ADICIONADOS_PORCENTO2" :options="formatoPercentual" class="form-control text-right"> </vue-autonumeric>
                  </b-input-group>
                  <b-input-group>
                    <template #prepend>
                      <span class="input-group-text prepend-160">Ferro</span>
                    </template>
                    <b-form-input type="text"  v-model="registro.FERRO" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.FERRO_PORCENTO" :options="formatoPercentual"  class="form-control text-right"> </vue-autonumeric>
                    <b-form-input type="text"  v-model="registro.FERRO2" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.FERRO_PORCENTO2" :options="formatoPercentual" class="form-control text-right"> </vue-autonumeric>
                  </b-input-group>
                   <b-input-group>
                    <template #prepend>
                      <span class="input-group-text prepend-160">Sódio</span>
                    </template>
                    <b-form-input type="text"  v-model="registro.SODIO" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.SODIO_PORCENTO" :options="formatoPercentual"  class="form-control text-right"> </vue-autonumeric>
                    <b-form-input type="text"  v-model="registro.SODIO2" class="text-right"></b-form-input>
                    <vue-autonumeric           v-model="registro.SODIO_PORCENTO2" :options="formatoPercentual" class="form-control text-right"> </vue-autonumeric>
                  </b-input-group>

                </b-col>
                   
              </b-row>
              <b-row>
                <b-col sm="6" class="mt-2">
                    <b-form-fieldset label="Observações Nutricionais">
                      <b-form-input type="text"  v-model="registro.OBSERVACOES_NUTRICIONAIS"></b-form-input>
                  </b-form-fieldset>
                </b-col>
              </b-row>
            </b-tab>
            <b-tab>
              <template #title>
                <i class='fa fa-money'></i><strong> Preços e Custos</strong>
              </template>
              <b-row>
                <b-col sm="2">
                  <b-form-fieldset label="Preço Venda">
                    <vue-autonumeric  v-model="registro.VL_VENDA" :options="formatoMoeda"  class="form-control text-right"> </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="Preço Promocional">
                    <vue-autonumeric  v-model="registro.VL_VENDAPRO" :options="formatoMoeda"  class="form-control text-right"> </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="Desconto Máximo %">
                    <vue-autonumeric  v-model="registro.VL_DESCONTO_PERCENTUAL" :options="formatoPercentual"  class="form-control text-right"> </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="Desconto Máximo R$">
                    <vue-autonumeric  v-model="registro.VL_DESCONTO" :options="formatoMoeda"  class="form-control text-right"> </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="Tipo de Desconto">
                    <b-form-select 
                          :plain="true" 
                          v-model="registro.OP_TIPO_DESCONTO" 
                          :options="optionsOP_TIPO_DESCONTO">
                    </b-form-select>
                  </b-form-fieldset>
                </b-col>
              </b-row>
              <b-row>
                
                <b-col sm="3">
                  <b-form-group
                      id="grupoCGC"
                      description="Use o botão consultar ou Atualizar o Custo."
                      label="Custo Atual R$"
                      label-for="edCNPJ"
                      valid-feedback="Gerado!">
                    <b-input-group  :aria-hidden="cep.busy ? 'true' : null">
                      <vue-autonumeric  v-model="registro.VL_CUSTO" :options="formatoMoeda"  class="form-control text-right"> </vue-autonumeric>
                            
                      <b-input-group-append>
                        <b-button v-if="habilitaGruposFilhos == true"
                                  ref="btabrirModalHistoricoCompras" 
                                  variant="primary"  
                                  @click.stop.prevent="abrirModalHistoricoCompras()">
                            <i class="fa fa-eye"></i>  
                          Ultimas Compras
                        </b-button>
                        <b-button v-if="habilitaGruposFilhos == true"
                                  ref="btConsultarJuridica" 
                                  variant="primary"  
                                  @click.stop.prevent="consultarJuridica()">
                            <i class="fa fa-random"></i>      
                          Atualizar
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-tab>
            
            <b-tab>
              <template #title>
                <i class='fa fa-money'></i><strong> ICMS, PIS E COFINS</strong>
              </template>
              <b-row>
                <b-col sm="4">
                  <b-form-fieldset label="ICMS Operação Estadual">
                    <b-form-select 
                          :plain="true" 
                          v-model="registro.TRIBUTACAO_ICMS_INTERNA_ID" 
                          :options="optionsTRIBUTACAO_ICMS_INTERNA_ID">
                    </b-form-select>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="4">
                  <b-form-fieldset label="ICMS Operação Interestadual">
                    <b-form-select 
                          :plain="true" 
                          v-model="registro.TRIBUTACAO_ICMS_EXTERNA_ID" 
                          :options="optionsTRIBUTACAO_ICMS_EXTERNA_ID">
                    </b-form-select>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="4">
                  <b-form-fieldset label="ICMS Operação Exterior">
                    <b-form-select 
                          :plain="true" 
                          v-model="registro.TRIBUTACAO_ICMS_EXTERIOR_ID" 
                          :options="optionsTRIBUTACAO_ICMS_EXTERIOR_ID">
                    </b-form-select>
                  </b-form-fieldset>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6">
                  <b-form-fieldset label="PIS Situação Tributária">
                    <b-form-select 
                          :plain="true" 
                          v-model="registro.OP_PIS_SITUACAO_TRIBUTARIA" 
                          :options="pis.opTipoSituacaoTributaria">
                    </b-form-select>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="PIS Situação Tributária">
                    <b-form-select 
                          :plain="true" 
                          v-model="registro.OP_PIS_TIPO_CALCULO" 
                          :options="pis.opTipoCalculo">
                    </b-form-select>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="Alíquota %">
                    <vue-autonumeric  v-model="registro.VL_PIS_ALIQUOTA_PERCENT" :options="formatoPercentual"  class="form-control text-right"> </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="Alíquota R$">
                    <vue-autonumeric  v-model="registro.VL_PIS_ALIQUOTA_REAIS" :options="formatoMoeda"  class="form-control text-right"> </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
              </b-row>
              <hr>
              <b-row>
                <b-col sm="6">
                  <b-form-fieldset label="COFINS Situação Tributária">
                    <b-form-select 
                          :plain="true" 
                          v-model="registro.OP_COFINS_SITUACAO_TRIBUTARIA" 
                          :options="cofins.opTipoSituacaoTributaria">
                    </b-form-select>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="COFINS Situação Tributária">
                    <b-form-select 
                          :plain="true" 
                          v-model="registro.OP_COFINS_TIPO_CALCULO" 
                          :options="cofins.opTipoCalculo">
                    </b-form-select>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="Alíquota %">
                    <vue-autonumeric  v-model="registro.VL_COFINS_ALIQUOTA_PERCENT" :options="formatoPercentual"  class="form-control text-right"> </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="Alíquota R$">
                    <vue-autonumeric  v-model="registro.VL_COFINS_ALIQUOTA_REAIS" :options="formatoMoeda"  class="form-control text-right"> </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
              </b-row>
              
            </b-tab>
            <b-tab v-if="habilitaGruposFilhos == true" >
              <template #title>
                <i class='fa fa-hand-scissors-o'></i><strong> Beneficiamento</strong>
              </template>
              <b-row>
                <b-col sm="1">
                  <b-form-fieldset label="Sexo">
                    <b-form-select 
                          :plain="true" 
                          v-model="registro.SEXO" 
                          :options="optionsSEXO">
                    </b-form-select>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="Parte">
                    <b-form-select 
                          :plain="true" 
                          v-model="registro.PARTE" 
                          :options="optionsPARTE">
                    </b-form-select>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="% do Beneficiado:">
                    <vue-autonumeric  v-model="registro.PESO_POR_ANIMAL" :options="formatoPercentual"  class="form-control text-right"> </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
                <b-col sm="2">
                  <b-form-fieldset label="Peças Por Animal:">
                    <vue-autonumeric  v-model="registro.PECAS_POR_ANIMAL" :options="formatoPecas"  class="form-control text-right"> </vue-autonumeric>
                  </b-form-fieldset>
                </b-col>
              </b-row>
              <b-row class=" mt-0 mb-1 text-right">
                <b-col sm="12">
                  <b-button 
                            variant="success"
                            @click.stop="abrirModalBeneficiamento()"
                            
                            ref="btAdicionarBeneficiamento"
                            v-b-popover.hover.left="'Incluir'"
                            type="button"  > 
                        <i class="fa fa-plus"></i> Adicionar
                  </b-button>
                </b-col>
              
              </b-row>
              <b-row>
                <div class="col-sm-12">
                      <b-table 
                        striped 
                        hover 
                        show-empty
                        empty-text="Nenhum Lançamento "
                        stacked="md"
                        small
                        select-mode="single"
                        head-variant="dark"
                        bordered
                        responsive
                        @row-clicked="abrirModalBeneficiamento"
                        :items="beneficiamento.items" 
                        :fields="beneficiamento.fields">
                        <template #cell(actions)="item" class="p-0">
                          <b-button 
                                    type="button"  
                                    size="sm" variant="danger"  
                                    @click.stop="deleteBeneficiamento(item.item)"
                                    v-b-popover.hover.left="'Remover'">
                            <i class="fa fa-close"></i>
                          </b-button>
                          
                          
                        </template>
                    </b-table>
                </div>
              </b-row>
            </b-tab>
            <b-tab v-if="habilitaGruposFilhos == true" >
              <template #title>
                <i class='fa fa-tasks'></i><strong> Trilha de Auditoria</strong>
              </template>
              <b-row class="mb-2">
                <b-col sm="2">
                  <b-form-fieldset label="Data Inicial">
                       <b-form-input  type="date" id="dt1" ref="dt1" placeholder="Informe a data Inicio" v-model="trilha.dt1"/>
                  </b-form-fieldset>
                </b-col>  
                <b-col sm="2">
                  <b-form-fieldset label="Data Final">
                       <b-form-input  type="date" id="dt2" ref="dt2" placeholder="Informe a data Inicio" v-model="trilha.dt2"/>
                  </b-form-fieldset>
                </b-col>  
                <b-col sm="5">
                  <centro-estoque-pesquisa
                    @retornaId="trilha.centroEstoqueId = $event"
                    :idInicial="trilha.centroEstoqueId"
                    :classeRequired="true"
                    :desabilitarInput="false"
                    label="Centro Estoque"
                    id-modal="modalCentroEstoque"
                    id="edTrilhaCENTRO_ESTOQUE"
                    ref="edTrilhaCENTRO_ESTOQUE"
                    place=""
                    labelBotao="">
                  </centro-estoque-pesquisa>
                </b-col>  
                
                <b-col sm="1" class="d-flex mb-3 align-items-end">
                    <b-button 
                          type="button" 
                          :disabled="isBusy"  
                          variant="primary" 
                          @click.stop.prevent="listarTrilha()">
                        Listar
                      </b-button>
                </b-col>
                <b-col sm="2" class="d-flex mb-3 align-items-end">
                  <b-pagination class=" mb-0 bg-gray-100" :limit="2"  :total-rows="trilha.items.length" per-page="20" v-model="trilha.currentPage" />
                </b-col>
              </b-row>
              <b-row>
                <div class="col-sm-12">
                      <b-table 
                        striped 
                        hover 
                        show-empty
                        empty-text="Nenhum Lançamento "
                        stacked="md"
                        small
                        select-mode="single"
                        head-variant="dark"
                        bordered
                        per-page="20"
                        :current-page="trilha.currentPage"
                        responsive
                        :items="trilha.items" 
                        :fields="trilha.fields">
                    <template #cell(ENTRA_SAI)="item">
                      <b-badge pill :variant="colorirENTRA_SAI(item.item.ENTRA_SAI)">{{traduzirENTRA_SAI(item.item.ENTRA_SAI)}}</b-badge>
                    </template>      
                    </b-table>
                </div>
              </b-row>
            </b-tab>
            
          </b-tabs>
        </b-card>
      </div>
    </div>
    <!--  -----------------------------------------------------------------------------------
                                          MODAL HISTORICO COMPRAS
            ----------------------------------------------------------------------------------- -->
    <div>
      <b-modal ref="modal-historico-compras" 
          id="modal-historico-compras" 
          hide-header
          no-close-on-esc
          no-close-on-backdrop
          body-class="p-0"
          size="xl"
          headerClass= "p-2 border-bottom-0" 
          title="HISTORICO DE COMPRAS" >
        <b-card bg-variant="light">
            <div slot="header" class="d-flex align-items-center">
              <div>
                 HISTORICO DE COMPRAS: <strong>{{ registro.CODIGO }} - {{ registro.DESCRICAO }}</strong>
              </div>
              <b-pagination
                class="ml-auto"
                size="md"
                :total-rows="historicoCompras.items.length"
                :per-page="historicoCompras.perPage"
                v-model="historicoCompras.currentPage"
              />
            </div>
            <div>
              <b-table 
                striped 
                hover 
                show-empty
                empty-text="Nenhuma compra"
                stacked="md"
                small
                :per-page="historicoCompras.perPage"
                responsive 
                select-mode="single"
                head-variant="dark"
                :current-page="historicoCompras.currentPage"
                :items="historicoCompras.items" 
                :fields="historicoCompras.fields">
                <template #cell(RAZAOSOCIAL)="row">
                  {{ row.item.RAZAOSOCIAL }} - {{ row.item.FORNECEDOR_ID }} 
                </template>
              </b-table>
          </div>
        </b-card>

        <template #modal-footer="{ cancel }">
          <b-button    variant="danger" @click="cancel()">
            FECHAR
          </b-button>
          
        </template>
        
      </b-modal>
    </div>
    <!--  -----------------------------------------------------------------------------------
                                          MODAL BENEFICIAMENTO
            ----------------------------------------------------------------------------------- -->
    <div>
      <b-modal ref="modal-beneficiamento" 
          id="modal-beneficiamento" 
          hide-header
          no-close-on-esc
          no-close-on-backdrop
          centered
          body-class="p-0"
          size="lg"
          headerClass= "p-2 border-bottom-0" 
          title="Quantidade que será extraído do produto Principal" >
        <b-card bg-variant="light">
          <div slot="header" class="d-flex align-items-center">
            <div>
                Produto que irá compor o Produto Principal
            </div>
          </div>
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <produto-pesquisa 
                  @retornaId="beneficiamento.registro.PRODUTO_ID = $event"
                  :idInicial="beneficiamento.registro.PRODUTO_ID"
                  :desabilitarInput="beneficiamento.itemAlteracao"
                  :classeRequired="!beneficiamento.registro.PRODUTO_ID"
                  id="edCOD_PRO"
                  ref="edCOD_PRO"
                  label="Produto"
                  place="Informe o Produto"
                  labelBotao="">
                </produto-pesquisa>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="4">
              <b-form-group
                  description="Quantidade que será extraído do produto Principal"
                  label="Quantas Peças"
                  valid-feedback="Gerado!">
                <b-input-group  :aria-hidden="cep.busy ? 'true' : null">
                  <vue-autonumeric   
                      :options="formatoMoeda"  
                      v-model="beneficiamento.registro.PECAS"
                      :class="['form-control text-right',
                                          {
                                            'is-invalid': beneficiamento.registro.PECAS == null || beneficiamento.registro.PECAS == 0,
                                            'is-valid': beneficiamento.registro.PECAS != null
                                          }
                                        ]"> 
                  </vue-autonumeric>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group
                  description="Percentual que esse produto equivale no produto Principal"
                  label="Percentual"
                  valid-feedback="Gerado!">
                <b-input-group  >
                  <vue-autonumeric   
                    :options="formatoPercentual"  
                    v-model="beneficiamento.registro.PERCENTUAL"
                    :class="['form-control text-right',
                                          {
                                            'is-invalid': beneficiamento.registro.PERCENTUAL == null || beneficiamento.registro.PERCENTUAL == 0,
                                            'is-valid': beneficiamento.registro.PERCENTUAL != null
                                          }
                                        ]"> 
                  </vue-autonumeric>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-card>

        <template #modal-footer="{ cancel }">
          <b-button v-if="beneficiamento.emAlteracao" variant="success" @click.stop="editBeneficiamento()">
            <u>G</u>ravar Alteração
          </b-button>
          <b-button v-else variant="success" @click.stop="postBeneficiamento()">
            <u>G</u>ravar Item
          </b-button>
          <b-button    variant="danger" @click="cancel()">
            FECHAR
          </b-button>
        </template>
        
      </b-modal>
    </div>
    

  </div>
</template>

<script>
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import VendedorPesquisa from '../../pesquisa/VendedorPesquisa.vue'
import TabelaPrecoPesquisa from '../../pesquisa/TabelaPrecoPesquisa.vue'
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import GrupoProdutoPesquisa from '../../pesquisa/GrupoProdutoPesquisa.vue'
import ProdutoPesquisa from '../../pesquisa/ProdutoPesquisa.vue'
import CentroEstoquePesquisa from '../../pesquisa/CentroEstoquePesquisa.vue'
import {Money} from 'v-money'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAutonumeric from 'vue-autonumeric'
import Tools from '@/tools/tools.js'
import moment from 'moment'

export default {
  components: {
    VueButtonSpinner,
    VendedorPesquisa,
    ClientePesquisa,
    TabelaPrecoPesquisa,
    GrupoProdutoPesquisa,
    ProdutoPesquisa,
    CentroEstoquePesquisa,
    Money,
    axios,
    VueAxios,
    VueAutonumeric
  },
  data () {
    return {
      desabilitado: true,
      items: [],
      estados: [],
      municipios: [],
      municipiosBusy: false,
      isLoading: false,
      submmited: false,
      status: '',
      permiteAtualizarCredito: false,
      formatoQuantidade: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        decimal: ',',
        precision: 3
      },
      formatoPecas: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        decimalPlaces: '0',
        roundingMethod: 'U',
        minimumValue: '0'
      },
      formatoPercentual: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        decimalPlaces: '3',
        roundingMethod: 'U',
        minimumValue: 0,
        maximumValue: 100,
        suffixText: ' %',
        modifyValueOnWheel: false
        
      },
      formatoMoeda: {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        decimalPlaces: '2',
        roundingMethod: 'U',
        minimumValue: 0,
        prefix: 'R$: ',
        modifyValueOnWheel: false
        
      },
      historicoCompras: {
        nomeProduto: '',
        currentPage: 1,
        emAlteracao: false,
        perPage: 20,
        items: [],
        fields: [
          {
            key: "DT_CONFERENCIA_INICIO",
            label: 'Data', 
            sortable: true,
            thStyle: { width: "20%" },
            formatter: (value, key, item) => 
              value ? moment(String(value)).format('DD/MM/YYYY') : null
          },
          {
            key: "RAZAOSOCIAL",
            label: 'Nome',
            thStyle: { width: "40%" }
          }
          ,
          {
            key: "QUANT_CONFERENCIA",
            label: 'Quant Confe',
            class:'align-middle text-right p-0',
            thStyle: { width: "10%" },
            formatter: (value, key, item) => 
                value && value > 0.00 ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3}) : 0.00
          },
          {
            key: "QT_PECAS",
            label: 'Unidades',
            thStyle: { width: "10%" },
            class:'align-middle text-right p-0'
          },
          {
            key: 'VL_UNITARIO_FOB', 
            class:'align-middle text-right p-0',
            thStyle: { width: "10%" },
            label: 'Preço',
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
          },
          {
            key: 'VL_TOTAL_FOB', 
            class:'align-middle text-right p-0',
            thStyle: { width: "10%" },
            label: 'Total',
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
          }
        ]
      },
      beneficiamento: {
        currentPage: 1,
        perPage: 5,
        emAlteracao: false,
        registro: {
          ID: null,
          PRODUTO_MESTRE_ID: null,
          PRODUTO_ID: null,
          PECAS: null,
          PERCENTUAL: null
        },
        items: [],
        fields: [
          {
            key: "PRODUTO_MESTRE_ID",
            label: 'Produto ID',
            thStyle: { width: "10%" }
          },
          {
            key: "DESCRICAO",
            label: 'Descrição',
            thStyle: { width: "65%" }
          },
          {
            key: "PECAS",
            label: 'Unidades',
            thStyle: { width: "10%" },
            class:'align-middle text-right p-0'
          },
          {
            key: 'PERCENTUAL', 
            class:'align-middle text-right p-0',
            thStyle: { width: "10%" },
            label: 'Percentual %',
            formatter: (value, key, item) => 
                value = value ? value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 0.00
          },
          {
            key: "actions",
            class:'align-middle text-center p-0',
            label: '',
            thStyle: { width: "5%" }
          }
        ]
      },
      trilha: {
        currentPage: 1,
        perPage: 10,
        dt1: Tools.getDataAtual(),
        dt2: Tools.getDataAtual(),
        items: [],
        fields: [
          {
            key: "ORDEM",
            label: '',
            class:'align-middle text-right p-0',
            thStyle: { width: "10%" }
          },
          {
            key: "ENTRA_SAI",
            label: 'E/A',
            class:'align-middle text-center p-0',
            thStyle: { width: "10%" }
          },
          {
            key: "TIPO",
            label: 'Tipo',
            thStyle: { width: "25%" },
            class:'align-middle  p-0'
          },
          {
            key: "NOME_CLIENTE",
            label: 'Cliente',
            thStyle: { width: "25%" }
          },
          {
            key: "DIA",
            label: 'Data', 
            thStyle: { width: "10%" },
            class:'align-middle text-right p-0',
            sortable: true,
            formatter: (value, key, item) => 
              value ? moment(String(value)).format('DD/MM/YYYY') : null
          },
          {
            key: "QUANT",
            class:'text-right', 
            thStyle: { width: "10%" },
            label: 'Peso Kg/Quant',
            formatter: (value, key, item) => 
                value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 3})
          },
          {
            key: "PECAS",
            class:'text-right', 
            thStyle: { width: "10%" },
            label: 'Peças'
          }
        ]
      },
      
      optionsID_UNIDADE_COMERCIAL: [
        {value: null, text: 'Informe UND'}
      ],
      cep: {
        busy : false,
        submmited : false
      },
      optionsTRIBUTACAO_ICMS_INTERNA_ID: [
        { value: null, text: 'Selecione - Opcional' },
      ],
      optionsTRIBUTACAO_ICMS_EXTERNA_ID: [
        { value: null, text: 'Selecione - Opcional' },
      ],
      optionsTRIBUTACAO_ICMS_EXTERIOR_ID: [
        { value: null, text: 'Selecione - Opcional' },
      ],
      optionsOP_TIPO_ESTOCAGEM: [
        { value: null, text: '' },
        { value: 'A', text: 'Ambiente' },
        { value: 'R', text: 'Resfriado' },
        { value: 'C', text: 'Congelado' },
      ],
      optionsFORMATO_EMBALAGEM_ID: [
        { value: null, text: '' }
      ],
      optionsETIQUETAS: [
        { value: null, text: '' }
      ],
      
      optionsOP_TIPO_DESCONTO: [
        { value: null, text: '' },
        { value: 'P', text: 'Percentual' },
        { value: 'V', text: 'Valor' }
      ],
      optionsCOR_ID: [
        { value: null, text: '' }
      ],
      optionsMATERIAL_ID: [
        { value: null, text: '' }
      ],
      optionsSEXO: [
        { value: null, text: '' },
        { value: 'M', text: 'Macho' },
        { value: 'F', text: 'Fêmea' }
      ],
      optionsPARTE: [
        { value: null, text: '' },
        { value: 'D', text: 'Dianteiro' },
        { value: 'T', text: 'Traseiro' },
        { value: 'M', text: 'Banda' },
        { value: 'P', text: 'Ponta de Agulha' },
        { value: 'S', text: 'Serrote' },
      ],
      pis:{
          opTipoSituacaoTributaria: [
            { value: '01', text : 'PIS 01 - Operação Tributável - Base de Cálculo = Valor da Operação Alíquota Normal (Cumulativo/Não Cumulativo)'},
            { value: '02', text : 'PIS 02 - Operação Tributável - Base de Cálculo = Valor da Operação (Alíquota Diferenciada)'},
            { value: '03', text : 'PIS 03 - Operação Tributável - Base de Cálculo = Quantidade Vendida x Alíquota por Unidade de Produto'},
            { value: '04', text : 'PIS 04 - Operação Tributável - Tributação Monofásica - (Alíquota Zero)'},
            { value: '06', text : 'PIS 06 - Operação Tributável - Alíquota Zero'},
            { value: '07', text : 'PIS 07 - Operação Isenta da Contribuição'},
            { value: '08', text : 'PIS 08 - Operação sem Incidência da Contribuição'},
            { value: '09', text : 'PIS 09 - Operação com Suspensão da Contribuição'},
            { value: '99', text : 'PIS 99 - Outras Operações'}
          ],
          opTipoCalculo: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ],
          opTipoCalculoST: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ]
        },
        cofins:{
          opTipoSituacaoTributaria: [
            { value: '01', text: 'COFINS 01 - Operação Tributável - Base de Cálculo = Valor da Operação Alíquota Normal (Cumulativo/Não Cumulativo)'},
            { value: '02', text: 'COFINS 02 - Operação Tributável - Base de Cálculo = Valor da Operação (Alíquota Diferenciada)'},
            { value: '03', text: 'COFINS 03 - Operação Tributável - Base de Cálculo = Quantidade Vendida x Alíquota por Unidade de Produto'},
            { value: '04', text: 'COFINS 04 - Operação Tributável - Tributação Monofásica - (Alíquota Zero)'},
            { value: '06', text: 'COFINS 06 - Operação Tributável - Alíquota Zero'},
            { value: '07', text: 'COFINS 07 - Operação Isenta da Contribuição'},
            { value: '08', text: 'COFINS 08 - Operação sem Incidência da Contribuição'},
            { value: '09', text: 'COFINS 09 - Operação com Suspensão da Contribuição'},
            { value: '99', text: 'COFINS 99 - Outras Operações'}
          ],
          opTipoCalculo: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ],
          opTipoCalculoST: [
            { value: '', text : ''},
            { value: '1', text : 'Percentual'},
            { value: '2', text : 'Valor'}
          ]
        },
        registro: {
          CODIGO                           : null,
          DESCRICAO                        : null,
          REZUMIDO                         : null,
          EAN                              : null,
          COD_FOR                          : null,
          COD_GRUP                         : null,
          UND_ENT                          : null,
          UND_SAI                          : null,
          UND_PECAS                        : null,
          VL_CUSTO                         : null,
          PECAS                            : null,
          MARGEM_FIL                       : null,
          MARGEM_CLI                       : null,
          VL_VENDA                         : null,
          SALDO_FI                         : null,
          SALDOFI_PECAS                    : null,
          SALDOFI_NOTA                     : null,
          SALDOPECAS_NOTA                  : null,
          EST_MAX                          : null,
          EST_MIN                          : null,
          GIRO_ENT                         : null,
          GIRO_SAI                         : null,
          MEMO1                            : null,
          MEMO2                            : null,
          MEMO3                            : null,
          DATALT                           : null,
          DT_ULTMOV                        : null,
          TRANSFERE                        : null,
          STATUS_VEN                       : null,
          STATUS_EST                       : null,
          VL_VENDAPRO                      : null,
          DT_INICIOPRO                     : null,
          DT_FIMPRO                        : null,
          VL_CLIENTE                       : null,
          MARGEM                           : null,
          COD_TIPO                         : null,
          CLASSEFISCAL                     : null,
          IPI                              : null,
          ISS                              : null,
          IRRF                             : null,
          COD_ARMAZENA                     : null,
          PESO                             : null,
          PROSERV                          : null,
          ST                               : null,
          QT_EMBALAGEM                     : null,
          EMBALAGEM                        : null,
          OP_BANDA_ABATE                   : null,
          ID_UNIDADE_COMERCIAL             : null,
          OP_IPI_SITUACAO_TRIBUTARIA       : null,
          OP_IPI_CLASS_ENQ_CIG_BEB         : null,
          TX_IPI_CODIGO_ENQUAD_LEGAL       : null,
          TX_IPI_CNPJ_PRODUTOR             : null,
          TX_IPI_NUM_SELO_CONTROLE         : null,
          OP_IPI_TIPO_CALCULO              : null,
          VL_IPI_ALIQUOTA                  : null,
          VL_IPI_QUANT_TOTAL_UND_PADRAO    : null,
          VL_IPI_UNIDADE                   : null,
          VL_IPI                           : null,
          OP_PIS_SITUACAO_TRIBUTARIA       : null,
          OP_PIS_TIPO_CALCULO              : null,
          VL_PIS_BASE_CALC                 : null,
          VL_PIS_ALIQUOTA_PERCENT          : null,
          VL_PIS_ALIQUOTA_REAIS            : null,
          VL_PIS_QUANT_VENDIDA             : null,
          VL_PIS                           : null,
          OP_PISST_TIPO_CALCULO            : null,
          VL_PISST_BASE_CALC               : null,
          VL_PISST_ALIQUOTA_PERCENT        : null,
          VL_PISST_ALIQUOTA_REAIS          : null,
          VL_PISST_QUANT_VENDIDA           : null,
          VL_PISST                         : null,
          OP_COFINS_SITUACAO_TRIBUTARIA    : null,
          OP_COFINS_TIPO_CALCULO           : null,
          VL_COFINS_BASE_CALC              : null,
          VL_COFINS_ALIQUOTA_PERCENT       : null,
          VL_COFINS_ALIQUOTA_REAIS         : null,
          VL_COFINS_QUANT_VENDIDA          : null,
          VL_COFINS                        : null,
          OP_COFINSST_TIPO_CALCULO         : null,
          VL_COFINSST_BASE_CALC            : null,
          VL_COFINSST_ALIQUOTA_PERCENT     : null,
          VL_COFINSST_ALIQUOTA_REAIS       : null,
          VL_COFINSST_QUANT_VENDIDA        : null,
          VL_COFINSST                      : null,
          TX_OBSERVACOES                   : null,
          VL_IPI_BASE_CALC                 : null,
          TX_NCM                           : null,
          ID_PRODUTO_SUBGRUPO              : null,
          PESO_LIQUIDO                     : null,
          TIPO_ID                          : null,
          CEST                             : null,
          VALIDADE                         : null,
          SEXO                             : null,
          OP_ANIMAL                        : null,
          TEXTO_BOTAO                      : null,
          PARTE                            : null,
          PERCENTUAL_DIANTEIRO             : null,
          PERCENTUAL_TRASEIRO              : null,
          PRODUTO_DIANTEIRO_ID             : null,
          PRODUTO_TRASEIRO_ID              : null,
          OP_PRODUTO_PRODUCAO              : null,
          VEICULO_ID                       : null,
          OP_SITUACAO                      : null,
          USUARIO_CADASTRO                 : null,
          USUARIO_ALTERACAO                : null,
          DT_CADASTRO                      : null,
          DT_ALTERACAO                     : null,
          OP_CUSTO_MANUAL                  : null,
          OP_BENEFICIA                     : null,
          OP_PERMITE_VENDA                 : null,
          OP_PAGA_COMISSAO                 : null,
          OP_PRECO_VARIAVEL                : null,
          OP_SERVICO                       : null,
          OP_GRADE                         : null,
          OP_USAR_TABELA_PRECO             : null,
          OP_COMBUSTIVEL                   : null,
          OP_MOSTRAR_APP                   : null,
          OP_BANDA                         : null,
          OP_QUARTO                        : null,
          OP_BENEFICIADO                   : null,
          OP_ALMOXARIFADO                  : null,
          OP_AUTOMOVEL                     : null,
          OP_MATERIA_PRIMA                 : null,
          VL_DESCONTO_PERCENTUAL           : null,
          VL_DESCONTO                      : null,
          OP_TIPO_DESCONTO                 : null,
          OP_PESADO                        : null,
          PRODUTO_COSTELA_ID               : null,
          CAPACIDADE                       : null,
          UNIDADE_COMERCIAL_CAPACIDADE_ID  : null,
          MATERIAL_ID                      : null,
          OP_EMBALAGEM                     : null,
          FORMATO_EMBALAGEM_ID             : null,
          COR_ID                           : null,
          CARBOIDRATOS                     : null,
          PROTEINAS                        : null,
          GORDURAS_TRANS                   : null,
          GORDURAS_SATURADAS               : null,
          GORDURAS_TOTAIS                  : null,
          COLESTEROL                       : null,
          FIBRA_ALIMENTAR                  : null,
          FERRO                            : null,
          SODIO                            : null,
          OBSERVACOES_NUTRICIONAIS         : null,
          QUANTIDADE_PORCAO                : null,
          VALOR_ENERGETICO                 : null,
          OP_ESTOQUE                       : null,
          TARA_EMBALAGEM                   : null,
          ETIQUETA_EXPEDICAO_ID            : null,
          ETIQUETA_INTERNA_ID              : null,
          ETIQUETA_DESOSSA_ID              : null,
          OP_PESO_FIXO                     : null,
          MENSAGEM_ARMAZENAMENTO           : null,
          MENSAGEM_CONSERVACAO             : null,
          OP_TIPO_ESTOCAGEM                : null,
          TEMPERATURA_MINIMA               : null,
          CARBOIDRATOS_PORCENTO            : null,
          PROTEINAS_PORCENTO               : null,
          GORDURAS_TRANS_PORCENTO          : null,
          GORDURAS_SATURADAS_PORCENTO      : null,
          GORDURAS_TOTAIS_PORCENTO         : null,
          COLESTEROL_PORCENTO              : null,
          FIBRA_ALIMENTAR_PORCENTO         : null,
          FERRO_PORCENTO                   : null,
          SODIO_PORCENTO                   : null,
          QUANTIDADE_PORCAO_PORCENTO       : null,
          VALOR_ENERGETICO_PORCENTO        : null,
          TEMPERATURA_MAXIMA               : null,
          ETIQUETA_BENEFICIAMENTO_ID       : null,
          ETIQUETA_RESUMO_ABATE_ID         : null,
          COD_SUBGRUPO                     : null,
          CODIGO_CENTROCUSTO               : null,
          CODIGO_SUBCENTROCUSTO            : null,
          DESCRI_GRUPO_CORTES              : null,
          CALCIO                           : null,
          CALCIO_PORCENTO                  : null,
          CARBOIDRATOS2                    : null,
          PROTEINAS2                       : null,
          GORDURAS_TRANS2                  : null,
          GORDURAS_SATURADAS2              : null,
          GORDURAS_TOTAIS2                 : null,
          COLESTEROL2                      : null,
          FIBRA_ALIMENTAR2                 : null,
          FERRO2                           : null,
          SODIO2                           : null,
          OBSERVACOES_NUTRICIONAIS2        : null,
          QUANTIDADE_PORCAO2               : null,
          VALOR_ENERGETICO2                : null,
          CALCIO2                          : null,
          CARBOIDRATOS_PORCENTO2           : null,
          PROTEINAS_PORCENTO2              : null,
          GORDURAS_TRANS_PORCENTO2         : null,
          GORDURAS_SATURADAS_PORCENTO2     : null,
          GORDURAS_TOTAIS_PORCENTO2        : null,
          COLESTEROL_PORCENTO2             : null,
          FIBRA_ALIMENTAR_PORCENTO2        : null,
          FERRO_PORCENTO2                  : null,
          SODIO_PORCENTO2                  : null,
          QUANTIDADE_PORCAO_PORCENTO2      : null,
          VALOR_ENERGETICO_PORCENTO2       : null,
          CALCIO_PORCENTO2                 : null,
          SIE                              : null,
          PECAS_POR_ANIMAL                 : null,
          PESO_POR_ANIMAL                  : null,
          EMBALAGEM_INTERNA_ID             : null,
          ETIQUETA_RECEPCAO_ID             : null,
          PRECO_MINIMO                     : null,
          OP_CONFIRMAR_PECAS_EXPEDICAO     : null,
          ACUCARES_TOTAIS                  : null,
          ACUCARES_TOTAIS_PORCENTO         : null,
          ACUCARES_TOTAIS2                 : null,
          ACUCARES_TOTAIS_PORCENTO2        : null,
          ACUCARES_ADICIONADOS             : null,
          ACUCARES_ADICIONADOS_PORCENTO    : null,
          ACUCARES_ADICIONADOS2            : null,
          ACUCARES_ADICIONADOS_PORCENTO2   : null,
          TRIBUTACAO_ICMS_INTERNA_ID       : null,
          TRIBUTACAO_ICMS_EXTERNA_ID       : null,
          TRIBUTACAO_ICMS_EXTERIOR_ID      : null,
          ANO                              : null,
          NUMERO_INVENTARIO                : null,
          CLASSE                           : null,
          CODIGO_FABRICANTE                : null,
          CATEGORIA_ATIVO_ID               : null,
          EMPRESA_ID                       : null,
          OP_BEM_AGREGADO                  : null,
          DEPARTAMENTO_ID                  : null,
          OP_USO                           : null,
          OP_TIPO_BEM                      : null,
          DATA_IMPLANTACAO                 : null,
          DATA_AQUISICAO                   : null,
          VL_BEM                           : null,
          VL_DEPRECIACAO_ACUMULADO         : null,
          DATA_INICIO_DEPRECIACAO          : null,
        },
    }
  },
  
  methods: {
    async carregarUnidadeComercial() {

      try {
        const {data}  = await this.$http.get('/api/protected/unidadeComercial/getLista')
        
        for (const und of data ) {
          this.optionsID_UNIDADE_COMERCIAL.push({value: und.ID, text: und.ID})
        }
      } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel carregar as unidades comerciais!')
        return
      }
    },

    async carregarTributacao() {
      try {
        const { data = [] } = await this.$http.get('/api/protected/tributacaoIcms/listar')

        this.optionsTRIBUTACAO_ICMS_INTERNA_ID = data
          .filter(tipo => tipo.OP_DESTINO_OPERACAO === '1')
          .map(tipo => ({
            value: tipo.ID,
            text: tipo.DESCRICAO
          }))

        this.optionsTRIBUTACAO_ICMS_EXTERNA_ID = data
          .filter(tipo => tipo.OP_DESTINO_OPERACAO === '2')
          .map(tipo => ({
            value: tipo.ID,
            text: tipo.DESCRICAO
          }))  

        this.optionsTRIBUTACAO_ICMS_EXTERIOR_ID = data
          .filter(tipo => tipo.OP_DESTINO_OPERACAO === '3')
          .map(tipo => ({
            value: tipo.ID,
            text: tipo.DESCRICAO
          }))  
        
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel carregar os tipos de Tributação do ICMS!')
        return
      }
    },
    async carregarFormatoEmbalagem() {
      try {
        const {data } = await this.$http.get('/api/protected/formatoEmbalagem/listar')
        for (const und of data ) {
          this.optionsFORMATO_EMBALAGEM_ID.push({value: und.ID, text: und.NOME})
        }
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel carregar os Formatos de Embalagem!')
        return
      }
    },
    async carregarCores() {
      try {
        const {data } = await this.$http.get('/api/protected/cores/listar')
        for (const und of data ) {
          this.optionsCOR_ID.push({value: und.ID, text: und.NOME})
        }
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel carregar os tipos de cores!')
        return
      }
    },
    async carregarMateriais() {
      try {
        const {data } = await this.$http.get('/api/protected/materiais/listar')
        for (const und of data ) {
          this.optionsMATERIAL_ID.push({value: und.ID, text: und.NOME})
        }
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel carregar os tipos de materiais!')
        return
      }
    },
    async carregarEtiquetas() {
      try {
        const {data } = await this.$http.get('/api/protected/etiqueta/listar')
        for (const und of data ) {
          this.optionsETIQUETAS.push({value: und.ID, text: `${und.ID} - ${und.DESCRICAO}`})
        }
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel carregar os tipos de materiais!')
        return
      }
    },
    async carregarBeneficiamento() {
      try {
        const {data } = await this.$http.get(`/api/protected/produtoComposicao/getByProduto/${this.registro.CODIGO}`)
        this.beneficiamento.items = data
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel carregar os cortes do beneficiamento!')
        return
      }
    },
    
    async abrirModalHistoricoCompras() {
      try {
        this.$store.commit('controle/setAguardando', true)
        const { data } = await this.$http.get(`/api/protected/produto/getHistoricoCompras/${this.registro.CODIGO}`)
        this.historicoCompras.items = data ?? []
        this.$store.commit('controle/setAguardando', false)
        this.$refs['modal-historico-compras'].show()

      } catch(err) {
        this.$store.commit('controle/setAguardando', false)
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel carregar as Compras!')
        return
      }
    },
    async abrirModalBeneficiamento(item) {
      try {
        this.$store.commit('controle/setAguardando', true)
        if (item) {
      
          const {data} = await this.$http.get(`/api/protected/produtoComposicao/getById/${item.ID}`)
          if (!data || !data.length) {
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel abrir o registro!')
            return  
          }  
          
          this.beneficiamento.registro = data[0]
          this.beneficiamento.emAlteracao = true
      
        } else {
          this.beneficiamento.emAlteracao = false

          this.beneficiamento.registro.ID = null
          this.beneficiamento.registro.PRODUTO_ID = null
          this.beneficiamento.registro.PRODUTO_MESTRE_ID = this.registro.CODIGO
          this.beneficiamento.registro.PECAS = 0
          this.beneficiamento.registro.PERCENTUAL = 0
        }

        this.$refs['modal-beneficiamento'].show()
      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel abrir o registro!')
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async postBeneficiamento() {
      try {
        this.$store.commit('controle/setAguardando', true)
        
        await this.$http.post(`/api/protected/produtoComposicao/post`, this.beneficiamento.registro)
        await this.carregarBeneficiamento()
        this.$refs['modal-beneficiamento'].hide()

      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel gravar o registro!')
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    async editBeneficiamento() {
      try {
        this.$store.commit('controle/setAguardando', true)
        
        await this.$http.post(`/api/protected/produtoComposicao/edit`, this.beneficiamento.registro)
        await this.carregarBeneficiamento()

      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel alterar os dados do registro!')
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async deleteBeneficiamento(item) {
      const msg = await this.$bvModal.msgBoxConfirm('Remover o produto do beneficiamento?', {
        title: 'remover',
        size: 'sm',
        buttonSize: 'xl',
        okVariant: 'success',
        okTitle: 'SIM',
        cancelTitle: 'NÃO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true,
        noCloseOnEsc: true, 
        noCloseOnBackdrop: true
      })
      
      if (msg == false) return

      try {
        this.$store.commit('controle/setAguardando', true)
        
        await this.$http.post(`/api/protected/produtoComposicao/delete`, {id: item.ID})
        await this.carregarBeneficiamento()

      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel alterar os dados do registro!')
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }

    },

    async listarTrilha() {
      if (!this.trilha.centroEstoqueId) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Centro de Estoque!')
        return
      }
      if (!this.trilha.dt1 || !this.trilha.dt2) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Período!')
        return
      }
      const payloadTrilha = {
        dt1: this.trilha.dt1,
        dt2: this.trilha.dt2,
        centroEstoqueId: this.trilha.centroEstoqueId,
        produtoId: this.registro.CODIGO
      }  
      
      try {
        this.$store.commit('controle/setAguardando', true)
        
        const {data} = await this.$http.post(`/api/protected/estoque/listarTrilha`, payloadTrilha)
        this.trilha.items = data

      } catch(err) {
        console.log(err)
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Não foi possivel listar a trilha do produto!')
        return
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },
    
    voltar() {
      this.$router.push('/cadastros/produto/listagem')
    },
    onHidden_botaoGerarCEP() {
      // Return focus to the button
      if (this.registro.ENDERECO) {
        this.$refs.edNumero.focus()
      }
    },
    async onClick_botaoGerarCEP(cep) {
      if (this.validarCEP == false) {
        this.$root.$bvToast.toast(`Informe o CEP correto`, {
          title: 'Aviso',
          autoHideDelay: 1000,
          variant: 'danger',
          appendToast: true
        })
        this.$refs.edCEP.$el.focus()
        return
      }
      this.cep.submmited = true
      this.cep.busy = true
      let requisicao = axios.create({
        baseURL: `https://viacep.com.br/`
      })

      try {
          const response = await requisicao.get(`ws/${cep}/json/`)
          if (response.status === 200) {
              if (response.data.erro) {
                this.$root.$bvToast.toast(`CEP não localizado!!!`, {
                  title: 'Aviso',
                  autoHideDelay: 13000,
                  variant: 'warning',
                  appendToast: true
                })
                
                this.$refs.edCEP.$el.focus()
                this.$refs.edCEP.$el.select()
              }
              this.registro.ENDERECO = response.data.logradouro.toUpperCase()
              this.registro.COMPLEMENTO = response.data.complemento.toUpperCase()
              this.registro.BAIRRO = response.data.bairro.toUpperCase()
              this.registro.ID_UF = response.data.uf.toUpperCase()
              await this.getMunicipios()
              this.registro.ID_MUNICIPIO = response.data.ibge.toUpperCase()
              this.cep.busy = false
              this.cep.submmited = false
          } else {
            this.cep.busy = false
            this.cep.submmited = false
            this.$root.$bvToast.toast(`Erro ao consultar o CEP: ${error.message}`, {
              title: 'Aviso',
              autoHideDelay: 13000,
              variant: 'danger',
              appendToast: true
            })
            return null;
          }
      } catch (error) {
          this.cep.busy = false
          this.cep.submmited = false
          this.$root.$bvToast.toast(`Erro ao consultar o CEP: ${error.message}`, {
            title: 'Aviso',
            autoHideDelay: 13000,
            variant: 'danger',
            appendToast: true
          })

          return null;
      }
    },
    async postOrEdit () {
      if (this.avisos()) return
      
      try {
        this.$store.commit('controle/setAguardando', true)  
        if (!this.registro.CODIGO) {
          
          try {  
            const postPayload = {
              produto: this.registro,
              login: window.localStorage.getItem('login')
            }

            const { data } = await this.$http.post(`/api/protected/produto/post`, postPayload)
            
            if (!data || !data.produto) {
              Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Indisponível! Não foi possível cadastrar o Produto!' )  
              return
            }
            
            this.registro = data.produto
            
            
            this.$store.commit("produto/SET_LIMPAR", null)
            this.$store.commit("produto/SET_REGISTRO_SELECIONADO_ID", this.registro.CODIGO)
            this.$store.commit("produto/SET_ID", this.registro.CODIGO)
            this.$store.commit('produto/SET_PAGINA_ATUAL', 1)
            await this.$store.dispatch('produto/GET_LISTA')
            this.$store.commit("produto/SET_LIMPAR_APENAS_FILTRO", null) // limpar o filtro pq ja localizou o registro novo 

            this.$store.commit('controle/setAguardando', false)  

            const msg = await this.$bvModal.msgBoxConfirm('Produto cadastrado com Sucesso. Continuar Cadastrando?', {
              title: 'Sucesso',
              size: 'sm',
              buttonSize: 'xl',
              okVariant: 'success',
              okTitle: 'SIM',
              cancelTitle: 'NÃO',
              footerClass: 'p-2',
              hideHeaderClose: false,
              centered: true,
              noCloseOnEsc: true, 
              noCloseOnBackdrop: true
            })
            
            if (msg == true) return

            this.$router.push('/cadastros/produto/listagem')

          } catch(err) {
            console.log(err)
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Indisponível! Não foi possível gravar os dados do Produto' )
            return
          }

        } else {
          try {        
            const editPayload = {
              produto: this.registro,
              login: window.localStorage.getItem('login'),
              operacao: this.emAlteracao == true ? 'alt' : 'inc' //necessario para o backend entender se o form inicio como novo ou iniciou como edicao
            }
            let { data } = await this.$http.post(`/api/protected/produto/edit`, editPayload)
            this.registro = (data?.produto) ?? null

            this.$store.commit('controle/setAguardando', false)  

            this.$router.push('/cadastros/produto/listagem')

          } catch(err) {
            console.log(err)
            Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Operação Indisponível! Não foi possível gravar os dados do Produto' )
            return
          }

          
        }
      } finally {
        this.$store.commit('controle/setAguardando', false)  
      }
    },
    async getEstados () {
      try {
        const result = await this.$http.get('/api/protected/estados')
        this.estados = result.data
        await this.getMunicipios()
      } catch(err) {
        this.estados = []
      }
    },
    async getMunicipios () {
      this.municipiosBusy = true
      
      this.municipios = []
      this.municipiosBusy = false
      
      if (this.registro.ID_UF) {
        try {
          let result = await this.$http.get(`/api/protected/municipios/${this.registro.ID_UF}`)
          this.municipios = result.data
          this.municipiosBusy = false
        } catch(err) {
          this.municipiosBusy = false
        }
      }
      
    },
    limparRegistro () {
      Tools.resetToNull(this.registro, true)  

      this.registro.CODIGO = null
      this.registro.OP_PISST_TIPO_CALCULO = null
      this.registro.OP_PIS_TIPO_CALCULO = null
      this.registro.OP_PIS_SITUACAO_TRIBUTARIA = null
      this.registro.PROSERV = 'P'
      this.registro.STATUS_EST = 'ATIVO'
      this.registro.STATUS_VEN = 'ATIVO'
      this.registro.OP_SITUACAO = '1'
      this.registro.OP_PERMITE_VENDA = '1'
      this.registro.OP_PAGA_COMISSAO = '1';
      this.registro.OP_PRECO_VARIAVEL = null
      this.registro.OP_SERVICO = null
      this.registro.OP_GRADE = null
      this.registro.OP_USAR_TABELA_PRECO = null
      this.registro.OP_COMBUSTIVEL = null
      this.registro.OP_MOSTRAR_APP = '1';
      this.registro.OP_BANDA = null
      this.registro.OP_QUARTO = null
      this.registro.OP_BENEFICIADO = null
      this.registro.OP_ALMOXARIFADO = null
      this.registro.VL_DESCONTO_PERCENTUAL = 0.00
      this.registro.VL_DESCONTO = 0.00
      this.registro.OP_TIPO_DESCONTO = null,
      this.registro.OP_AUTOMOVEL = null
      this.registro.OP_MATERIA_PRIMA = null
      this.registro.OP_PESADO = null
      this.registro.OP_EMBALAGEM = null
      this.registro.OP_ESTOQUE = '1'
      this.registro.OP_PESO_FIXO = null
      
    },
    
    validarCNPJ(c) {
      var b = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

      if ((c = c.replace(/[^\d]/g, "")).length != 14)
          return false

      if (/0{14}/.test(c))
          return false

      for (var j = 0; j < 2; ++j) {
          for (var i = 0, n = 0; i < 12 + j; n += c[i] * b[++i - j])
          if (c[12 + j] != ((n %= 11) < 2) ? 0 : 11 - n)
              return false;
      }

      return true
    },
    avisos() {
      if (!this.registro.DESCRICAO) {
        this.$refs.edDESCRICAO.$refs.input.focus()
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Nome do Produto')
        return true
      }
      else if (!this.registro.REZUMIDO) {
        this.$refs.edREZUMIDO.$refs.input.focus()
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Nome Rezumido')
        return true
      }
      else if (!this.registro.ID_UNIDADE_COMERCIAL) {
        this.$refs.comboID_UNIDADE_COMERCIAL.$refs.input.focus()
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe a Unidade Comercializada')
        return true
      }
      else if (!this.registro.TX_NCM) {
        this.$refs.edTX_NCM.$refs.input.focus()
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe a NCM do Produto')
        return true
      }
      else if ((!this.registro.PESO) || (this.registro.PESO <= 0) ) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Peso Bruto do Produto (Necessário para Nfe)')
        return true
      }
      else if ((!this.registro.PESO_LIQUIDO) || (this.registro.PESO_LIQUIDO < 0) ) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Informe o Peso da Embalagem Produto (Necessário para Nfe)')
        return true
      }
      
      return false
      
    },
    traduzirENTRA_SAI(valor) {
      switch (valor) {
        case 'E':
          return 'Entrada'
        case 'S':
          return 'Saida'
        default:
          return ''
      }
    },
    colorirENTRA_SAI(valor) {
      switch (valor) {
        case 'E':
          return 'success'
        case 'S':
          return 'danger'
        default:
          return ''
      }
    }
    
  },
  computed: {
    habilitaGruposFilhos() {
      return this.registro.CODIGO != null && this.registro.CODIGO > 0
    },
    tamanhocampoPagina () {
      if (this.registro.PAGINA) {
        return this.registro.PAGINA.length > 2 ? null : false
      }
      return false
    }
  },
  async created () {
    const id = this.$route.params.id ? Number(this.$route.params.id) : null

    try {
      this.$store.commit('controle/setAguardando', true)  
      const loaders = [
        this.carregarUnidadeComercial(),
        this.carregarTributacao(),
        this.carregarFormatoEmbalagem(),
        this.carregarCores(),
        this.carregarMateriais(),
        this.carregarEtiquetas(),
      ]

      await Promise.all(loaders)

      
      if ( id ) {
        

        this.emAlteracao = true
        const { data: result } = await this.$http.get(`/api/protected/produto/getById/${id}`)
        if (!Array.isArray(result) || result.length === 0) {
          Tools.exibirMensagem(this.$store, 'Aviso', 'warning', 'Cadastro não localizado.')
          this.$router.replace('/cadastros/produto/listagem')
          return
        }
        
        this.registro = { ...result[0] }

        await this.carregarBeneficiamento()

      } else {
        this.emAlteracao = false
        await this.limparRegistro()
      }
    } catch(err) {
        Tools.exibirMensagem(this.$store, 'Aviso', 'warning', err )
        this.$router.replace('/cadastros/produto/listagem') 
    } finally {
      this.$store.commit('controle/setAguardando', false)  
    }
  },
  mounted (){
    this.$nextTick(() => {
      if (!this.$route.params.id) {
        // tenta API do componente; se não, foca no input interno
        const c = this.$refs.edDESCRICAO
        if (c?.focus) c.focus()
        else c?.$el?.querySelector('input')?.focus()
      }
    })
  },
  watch: {
    'registro.FORMA_PAGAMENTO': async function (val, oldVal) {
      if (!oldVal && val) {
        return
      }


      if (val === 'V') {
       this.registro.DIAS_INICIAR_PAGAMENTO = 0 
       this.registro.PRAZO = 0 
       this.registro.DIAS_ENTRE_PARCELAS = 0
      }
    },
    'registro.ID_UF': async function () {
      await this.getMunicipios()
    },
    'registro.FIZ_JUR': function () {
      if (this.registro.FIZ_JUR == '0' ) { //Fisica
        this.registro.RAZAOSOCIAL =  this.registro.NOME
      }
      else if (this.registro.FIZ_JUR == '2' ) { //Exterior
        this.registro.INS_EST = null
        this.registro.INS_SUFRAMA = null
      }

    }
  }
}
</script>
<style lang="css" scoped>
.prepend-160 {
  flex: 0 0 130px;   /* fixa a coluna */
  width: 130px;      /* redundante, mas ajuda em alguns temas */
  min-width: 130px;  /* garante que não encolha */
}
</style>




// WEBPACK FOOTER //
// src/views/almoxarifado/inventario/InventarioCadastro.vue